import { css } from 'lit';
export const alertStyles = css `
    :host {
        display: block;
    }

    .hlx-alert {
        display: flex;
        align-items: flex-start;
        min-width: 300px;
        border-radius: 0 var(--hlx-radius-sm) var(--hlx-radius-sm) 0;
    }

    .hlx-alert-brand {
        background-color: var(--hlx-alert-background-color-brand);
        border-left: 4px solid var(--hlx-alert-border-color-brand);
        color: var(--hlx-color-brand-default);
    }
    .hlx-alert-success {
        background-color: var(--hlx-alert-background-color-success);
        border-left: 4px solid var(--hlx-alert-border-color-success);
        color: var(--hlx-color-success-default);
    }
    .hlx-alert-error {
        background-color: var(--hlx-alert-background-color-error);
        border-left: 4px solid var(--hlx-alert-border-color-error);
        color: var(--hlx-color-error-default);
    }
    .hlx-alert-warning {
        background-color: var(--hlx-alert-background-color-warning);
        border-left: 4px solid var(--hlx-alert-border-color-warning);
        color: var(--hlx-text-color-default);
    }
    .hlx-alert-info {
        background-color: var(--hlx-alert-background-color-info);
        border-left: 4px solid var(--hlx-alert-border-color-info);
        color: var(--hlx-color-info-default);
    }

    .hlx-alert-icon {
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        padding-top: calc(var(--hlx-spacing-xl) + 4px);
        padding-bottom: var(--hlx-spacing-xl);
        padding-left: var(--hlx-spacing-xl);
        padding-right: var(--hlx-spacing-xs);
    }
    .hlx-alert-condensed .hlx-alert-icon {
        padding-top: calc(var(--hlx-spacing-lg) + 4px);
        padding-bottom: var(--hlx-spacing-lg);
        padding-left: var(--hlx-spacing-xl);
        padding-right: var(--hlx-spacing-xs);
    }

    .hlx-alert-body {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        gap: var(--hlx-spacing-xs);
        padding-top: var(--hlx-spacing-xl);
        padding-bottom: var(--hlx-spacing-xl);
    }
    .hlx-alert-condensed .hlx-alert-body {
        padding-top: var(--hlx-spacing-lg);
        padding-bottom: var(--hlx-spacing-lg);
    }

    .hlx-alert-message {
        display: none;
        font-family: var(--hlx-text-font-family-sans-serif);
        font-weight: var(--hlx-text-font-weight-medium);
        font-size: var(--hlx-text-font-size-md);
        line-height: var(--hlx-text-line-height-default);
    }
    .hlx-alert-has-message .hlx-alert-message {
        display: block;
    }
    .hlx-alert-message-slot {
        display: block;
        overflow: hidden;
    }

    .hlx-alert-description {
        display: none;
        color: var(--hlx-text-color-weak-1);
        font-family: var(--hlx-text-font-family-sans-serif);
        font-weight: var(--hlx-text-font-weight-normal);
        font-size: var(--hlx-text-font-size-md);
        line-height: var(--hlx-text-line-height-default);
    }
    .hlx-alert-has-description .hlx-alert-description {
        display: block;
    }
    .hlx-alert-description-slot {
        display: block;
        overflow: hidden;
    }

    .hlx-alert-action {
        position: relative;
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        overflow: hidden;
        outline: none;
        padding-top: var(--hlx-spacing-xl);
        padding-right: var(--hlx-spacing-xl);
    }
    .hlx-alert-condensed .hlx-alert-action {
        padding-top: var(--hlx-spacing-lg);
        padding-right: var(--hlx-spacing-xl);
    }

    .hlx-alert-close-button {
        top: -16px;
        right: -16px;
    }
`;
//# sourceMappingURL=alert.styles.js.map